var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrashSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.123 20.131L19.148 4.5H4.852l1.025 15.631A2 2 0 007.873 22h8.254a2 2 0 001.996-1.869zM3.5 4.5h17",
    stroke: "#213555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.742v-2a1 1 0 00-1-1h-6.5a1 1 0 00-1 1v2",
    stroke: "#213555"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 7.907,
    width: 1,
    height: 11.111,
    rx: 0.5,
    fill: "#213555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 7.907,
    width: 1,
    height: 11.111,
    rx: 0.5,
    fill: "#213555"
  })));
}
export default SvgIconTrashSmall;